import api from '../lib/api';
import type { MessageSchedule, MessageScheduleFilters } from '../types/message';

interface MessageScheduleResponse {
  data: MessageSchedule[];
  pagination: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

class MessageService {
  async getSchedules(filters?: MessageScheduleFilters, page: number = 1): Promise<MessageScheduleResponse> {
    const response = await api.get('/messages/schedules', { 
      params: {
        ...filters,
        page,
        limit: 20
      }
    });
    return response.data;
  }

  async createSchedule(data: Partial<MessageSchedule>): Promise<MessageSchedule> {
    const response = await api.post('/messages/schedules', data);
    return response.data;
  }

  async updateSchedule(id: number, data: Partial<MessageSchedule>): Promise<MessageSchedule> {
    const response = await api.put(`/messages/schedules/${id}`, data);
    return response.data;
  }

  async deleteSchedule(id: number): Promise<void> {
    await api.delete(`/messages/schedules/${id}`);
  }

  async clearSchedules(filters?: MessageScheduleFilters): Promise<{ deleted_count: number }> {
    const response = await api.delete('/messages/schedules/clear', { params: filters });
    return response.data;
  }

  async exportSchedulesCsv(filters?: MessageScheduleFilters): Promise<Blob> {
    const response = await api.get('/messages/schedules/export/csv', {
      params: filters,
      responseType: 'blob',
    });
    return response.data as Blob;
  }
}

export default new MessageService();